import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import "../assets/style.scss"
import { getCidParameter, getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"
import { useAppSelector } from "../../../config/hook"

const LandingHeader = () => {
  const sessionData = useAppSelector((state) => state.sessionData.response)

  const [campaignText, setCampaignText] = useState('')
  let cidParameter = getCidParameter();
  useEffect(() => {
    if (sessionData?.configList) {
      if (cidParameter != null) {
        if (!isNullOrEmpty(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Top.${cidParameter}`))) {
          setCampaignText(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Top.${cidParameter}`))
        }
        else {
          if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Top"))) {
            setCampaignText(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Top"))
          }
        }
      }
      else {
        if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Top"))) {
          setCampaignText(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Top"))
        }
      }
    }
  }, [sessionData])

  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper bapp-container">
        <Block className="landing-header-text" dangerouslySetInnerHTML={{ __html: campaignText }} />
      </Block>
      <Image path={"./img/poslead/poslead-header.png"} className="landing-header-img" />
    </Block>
  )
}

export default LandingHeader
